// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Scrollable$Showside from "./Scrollable.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as UseAnchorsType$Showside from "../hook/UseAnchorsType.bs.js";
import * as EditorLayer_Lazy$Showside from "./EditorLayer_Lazy.bs.js";
import * as WindowScrollable$Showside from "../utils/WindowScrollable.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as ListPageLayoutController$Showside from "../hook/ListPageLayoutController.bs.js";
function ListPageScrollableWrapper(Props) {
  var useWindow = Props.useWindow;
  var anchorHookResult = Props.anchorHookResult;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var innerContainerRef = Props.innerContainerRef;
  var children = Props.children;
  var match = EntrypointContext$Showside.use(undefined);
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var previewMode = match$1.previewMode;
  var match$2 = ConfigurationProvider$Showside.use(undefined).config;
  var match$3 = ListPageLayoutController$Showside.Context.use(undefined);
  var match$4 = match$3.state;
  var match$5 = Belt_Option.getWithDefault(anchorHookResult, UseAnchorsType$Showside.empty);
  var scrollToRef = match$5.scrollToRef;
  var editorLayer = React.createElement(ConditionalRender$Showside.When.make, {
    condition: Caml_obj.notequal(previewMode, /* PreviewLive */1) && previewMode !== undefined,
    children: React.createElement(EditorLayer_Lazy$Showside.make, {
      embedType: match.embedType,
      innerContainerRef: innerContainerRef,
      outerContainerRef: scrollableContainerRef
    })
  });
  if (useWindow) {
    var tmp = {
      children: null,
      onScroll: match$5.onScrollWindow
    };
    if (scrollToRef !== undefined) {
      tmp.scrollToRef = Caml_option.valFromOption(scrollToRef);
    }
    return React.createElement(WindowScrollable$Showside.make, tmp, children, editorLayer);
  }
  var tmp$1 = {
    restorationId: "list-page-" + match$2.id,
    onScroll: match$5.onScrollDiv,
    children: null,
    fwdRef: scrollableContainerRef,
    className: CSS$Showside.prefix("absolute top-0 left-0 w-full h-full"),
    defaultRestorationPosition: match$4.showPrimaryNavbar ? 0.0 : (match$4.primaryNavbarHeight + match$4.secondaryNavbarHeight | 0) + match$4.toolbarHeight | 0
  };
  if (scrollToRef !== undefined) {
    tmp$1.scrollToRef = Caml_option.valFromOption(scrollToRef);
  }
  return React.createElement(Scrollable$Showside.make, tmp$1, children, editorLayer);
}
ListPageScrollableWrapper.displayName = "ListPageScrollableWrapper";
var make = ListPageScrollableWrapper;
export { make };
/* react Not a pure module */